import { getDefaultCardList } from '@app/constants/telehealth';
import { coreClient as client } from '@app/helpers/requests/client';
import { responseFailed } from '@app/helpers/requests/bennieFetch';

export const fetchTelehealthConfiguration = async () => {
  try {
    const response = await client.get(`/v1/profile/telehealthconfiguration`);
    const { status, data } = response;

    if (responseFailed(status) || !Array.isArray(data) || data.length === 0) {
      return { telehealthConfiguration: getDefaultCardList(), isDefault: true };
    }

    return { telehealthConfiguration: data, isDefault: false };
  } catch (e) {
    return { telehealthConfiguration: getDefaultCardList(), isDefault: true };
  }
};
